import { IUserNotification, UserNotificationFactory } from "@edp-models/user-notification.model";
import { EdpUser, EdpUserFactory } from "@edp-models/user.model";
import { EUserActions, UserActions } from "@edp-store/actions/user.actions";
import { initialUserState, IUserState } from "@edp-store/state/user.state";
import moment from "moment";

export function userReducers(state = initialUserState, action: UserActions): IUserState {
    switch (action.type) {
        case EUserActions.SetUser: {
            return {
                ...state,
                user: action.user,
            };
        }
        case EUserActions.SetOnBoarding: {
            return {
                ...state,
                onboarding: action.onboarding,
            };
        }
        case EUserActions.SetLevelStatus: {
            return {
                ...state,
                levelStatus: action.levelStatus,
            };
        }
        case EUserActions.UserNotificationsSetList: {
            return {
                ...state,
                notifications: {
                    list: action.payload,
                    totalNotViewed: null,
                    lastAPIError: null,
                },
            };
        }
        case EUserActions.UserNotificationsSetTotalNotViewed: {
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    totalNotViewed: state.notifications.list.reduce((sum, record) => {
                        return record.isViewed() ? sum : sum + 1;
                    }, 0),
                },
            };
        }
        case EUserActions.APIError: {
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    lastAPIError: action.error,
                },
            };
        }
        case EUserActions.MarkNotificationReadedPersist: {
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    list: state.notifications.list.map(notification => {
                        if (notification.Id === action.payload.Id) {
                            notification = UserNotificationFactory.create({
                                ...notification,
                                Readed: {
                                    state: true,
                                    at: moment().toISOString(),
                                },
                            } as IUserNotification);
                        }

                        return notification;
                    }),
                    lastAPIError: null,
                },
            };
        }
        case EUserActions.MarkNotificationViewedPersist: {
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    list: state.notifications.list.map(notification => {
                        if (!notification.isViewed()) {
                            notification = UserNotificationFactory.create({
                                ...notification,
                                Viewed: {
                                    state: true,
                                    at: moment().toISOString(),
                                },
                            } as IUserNotification);
                        }

                        return notification;
                    }),
                    lastAPIError: null,
                },
            };
        }
        case EUserActions.IsUserEdpE: {
            return {
                ...state,
                isUserEdpE: action.payload,
            };
        }
        case EUserActions.SetPlanetAnniversary: {
            return {
                ...state,
                user: {
                    ...state.user,
                    edpEYearChange: action.payload,
                    b2bSegment: state.user.b2bSegment,
                    hasBusinessSegment: state.user.hasBusinessSegment,
                    hasVirtualSun: state.user.hasVirtualSun,
                },
            };
        }
        case EUserActions.SetCebrationZs: {
            return {
                ...state,
                celebrationZs: action.payload,
                lastCelebrationZs: action.payload > 0 ? action.payload : state.lastCelebrationZs,
            };
        }
        case EUserActions.SetProfileStatus: {
            return {
                ...state,
                profileStatus: action.payload,
            };
        }
        case EUserActions.SetTermsCond: {
            const userCopy = JSON.parse(JSON.stringify({ ...state.user, termsCond: true }));
            const user = EdpUserFactory.create(userCopy);
            return { ...state, user };
        }
        default:
            return state;
    }
}
